import {css} from "@panda/css";

import {Checkbox} from "@pg-design/checkbox-module";
import {Text} from "@pg-design/text-module";
import {areaFormat, numberFormat} from "@pg-mono/string-utils";

import {ISpace} from "./PropertyDetailAdditionalSpaces";

interface IProps {
    space: ISpace;
    onSpaceSelect: () => void;
}

const Price = ({space}: {space: ISpace}) => {
    // Zakładamy, że może się zdarzyć, że będzie obiekt mający zarówno cenę, jak i is_included_in_price === true. W takim przypadku traktujemy is_included_in_price jako warunek ważniejszy od ceny.
    if (space.is_included_in_price) {
        return (
            <Text variant="body_copy_2" strong className={priceInfoStyle}>
                W cenie
            </Text>
        );
    }
    if (space.price) {
        return (
            <span className={priceStyle}>
                <Text variant="body_copy_2" strong>
                    {numberFormat(space.price)}&nbsp;
                </Text>
                <Text variant="info_txt_2" strong>
                    zł
                </Text>
            </span>
        );
    }
    return (
        <Text variant="body_copy_2" strong className={priceInfoStyle}>
            Informacja u dewelopera
        </Text>
    );
};

export const AdditionalSpaceListItem = ({space, onSpaceSelect}: IProps) => {
    return (
        <li className={listItemWrapStyle}>
            <div className={listItemSectionStyle}>
                <div className={listItemLeftSectionWrapperStyle}>
                    <Checkbox
                        disabled={space.is_mandatory || space.is_included_in_price}
                        checked={space.selected}
                        onChange={onSpaceSelect}
                        name={`${space.id}-checkbox`}
                        checkedMarkColor="#02D054"
                    />
                    <div className={spaceDetailsStyle}>
                        <div>
                            <div className={spaceDetailsNameAreaStyle}>
                                <Text variant="info_txt_1">{space.name}</Text>
                                {space.area && <Text variant="info_txt_1">{`${areaFormat(space.area, {precision: 2})}`}</Text>}
                            </div>
                            {space.comment && <Text variant="info_txt_3">{space.comment}</Text>}
                        </div>
                        <Price space={space} />
                    </div>
                </div>
            </div>
        </li>
    );
};

const listItemWrapStyle = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 1,
    borderRadius: 2,
    backgroundColor: "var(--colors-gray-100)",
    color: "var(--colors-secondary)"
});

const listItemSectionStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.5rem",
    flex: 1,
    justifyContent: "space-between",
    flexWrap: "wrap"
});

const listItemLeftSectionWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    width: "100%"
});

const spaceDetailsStyle = css({
    xsDown: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1
});

const spaceDetailsNameAreaStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5,
    flexWrap: "wrap"
});

const priceStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline"
});

const priceInfoStyle = css({
    textAlign: "end",
    xsDown: {
        textAlign: "start"
    }
});
import {css} from "@panda/css";

import {Checkbox} from "@pg-design/checkbox-module";
import {Text} from "@pg-design/text-module";
import {areaFormat, numberFormat} from "@pg-mono/string-utils";

import {ISpace} from "./PropertyDetailAdditionalSpaces";

interface IProps {
    space: ISpace;
    onSpaceSelect: () => void;
}

const Price = ({space}: {space: ISpace}) => {
    // Zakładamy, że może się zdarzyć, że będzie obiekt mający zarówno cenę, jak i is_included_in_price === true. W takim przypadku traktujemy is_included_in_price jako warunek ważniejszy od ceny.
    if (space.is_included_in_price) {
        return (
            <Text variant="body_copy_2" strong className={priceInfoStyle}>
                W cenie
            </Text>
        );
    }
    if (space.price) {
        return (
            <span className={priceStyle}>
                <Text variant="body_copy_2" strong>
                    {numberFormat(space.price)}&nbsp;
                </Text>
                <Text variant="info_txt_2" strong>
                    zł
                </Text>
            </span>
        );
    }
    return (
        <Text variant="body_copy_2" strong className={priceInfoStyle}>
            Informacja u dewelopera
        </Text>
    );
};

export const AdditionalSpaceListItem = ({space, onSpaceSelect}: IProps) => {
    return (
        <li className={listItemWrapStyle}>
            <div className={listItemSectionStyle}>
                <div className={listItemLeftSectionWrapperStyle}>
                    <Checkbox
                        disabled={space.is_mandatory || space.is_included_in_price}
                        checked={space.selected}
                        onChange={onSpaceSelect}
                        name={`${space.id}-checkbox`}
                        checkedMarkColor="#02D054"
                    />
                    <div className={spaceDetailsStyle}>
                        <div>
                            <div className={spaceDetailsNameAreaStyle}>
                                <Text variant="info_txt_1">{space.name}</Text>
                                {space.area && <Text variant="info_txt_1">{`${areaFormat(space.area, {precision: 2})}`}</Text>}
                            </div>
                            {space.comment && <Text variant="info_txt_3">{space.comment}</Text>}
                        </div>
                        <Price space={space} />
                    </div>
                </div>
            </div>
        </li>
    );
};

const listItemWrapStyle = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 1,
    borderRadius: 2,
    backgroundColor: "var(--colors-gray-100)",
    color: "var(--colors-secondary)"
});

const listItemSectionStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.5rem",
    flex: 1,
    justifyContent: "space-between",
    flexWrap: "wrap"
});

const listItemLeftSectionWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    width: "100%"
});

const spaceDetailsStyle = css({
    xsDown: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1
});

const spaceDetailsNameAreaStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5,
    flexWrap: "wrap"
});

const priceStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline"
});

const priceInfoStyle = css({
    textAlign: "end",
    xsDown: {
        textAlign: "start"
    }
});
